<template>
  <div>
    <Breadcrumbs
      :paths="[$route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.common.user") }}{{ $t("message.common.any_list") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click="get_data(get_prefix() + 'user/', ['list'])">
              mdi-refresh
            </v-icon>
          </template>
          <span>{{ $t("message.common.refresh") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click="$router.push('/' + get_prefix() + 'user/regist')">
              mdi-account-plus
            </v-icon>
          </template>
          <span>{{ $t("message.common.regist") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click="$router.push('/' + get_prefix() + 'user/batch')">
              mdi-import
            </v-icon>
          </template>
          <span>{{ $t("message.common.batch") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click="get_user_list()">
              mdi-export
            </v-icon>
          </template>
          <span>{{ $t("message.user.get_user_list") }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click="$refs.usage_list && $refs.usage_list.open(data)" :disabled="data.length == 0">
              mdi-file-excel
            </v-icon>
          </template>
          <span>{{ $t("message.common.get_excel") }}</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-card class="d-flex justify-center mb-1 mt-1">
      <v-card flat class="pa-2">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          clearable
          :label="$t('message.common.uid')"
          v-model="search_uid"
        >
        </v-text-field>
      </v-card>
      <v-card flat class="pa-2">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          clearable
          :label="$t('message.common.name')"
          v-model="search_name"
        >
        </v-text-field>
      </v-card>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="data"
      :sort-by="['ctime']"
      :sort-desc="[true]"
      must-sort
      class="elevation-1"
      @click:row="$router.push('/' + get_prefix() + 'user/' + $event.uid + get_referer());"
      :footer-props="{
        'items-per-page-options': [10, 100, 200, 500]
      }"
    >
      <template v-slot:item.uid="{ item }">
        {{ item.uid }}
      </template>
      <template v-slot:item.name="{ item }">
        <template v-if="item.name">
          {{ item.name }}
        </template>
        <template v-else>
          ({{ item.user }})
        </template>
      </template>
      <template v-slot:item.operation="{ item }">
        <!--<v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click.stop="$router.push('/' + get_prefix() + 'user/' + item.uid + '/web_socket' + get_referer())">
              mdi-network-outline
            </v-icon>
          </template>
          <span>{{ $t("message.common.web_socket") }}</span>
        </v-tooltip>-->
        <template v-if="deletable(item)">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="delete_dependency(item.uid, item.iid)">
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t("message.common.delete") }}</span>
          </v-tooltip>
        </template>
      </template>
    </v-data-table>
    <v-overlay
      :absolute="true"
      :value="progress_overlay"
    >
      <v-progress-circular
        :value="progress"
      >
        {{ progress }}
      </v-progress-circular>
    </v-overlay>
    <Confirm
      ref="delete_confirm"
      :message="$t('message.common.delete_confirm')"
      :positive="$t('message.common.yes')"
      :negative="$t('message.common.no')"
    >
    </Confirm>
    <Confirm
      ref="user_list_confirm"
      negative="OK"
    >
      <Complete
        command_type="user_list"
        :jobs="user_list_jobs"
        :show_link="false"
        :mode="mode"
      >
        <template v-slot:title>
          <v-card flat class="pb-2">
            {{ $t("message.user.accept_user_list") }}
          </v-card>
        </template>
      </Complete>
    </Confirm>
    <CheckDependency
      ref="check_dependency"
      :is_reject="false"
      :deletable_message="$t('message.common.delete_dependency_all')"
    >
    </CheckDependency>
    <UsageList
      ref="usage_list"
      module="user"
      id_name="uid"
      :mode="mode"
    >
    </UsageList>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import Confirm from '../components/Confirm';
import Complete from '../components/Complete';
import CheckDependency from '../components/CheckDependency';
import UsageList from '../components/UsageList';
import { res_list } from "../js/res_list";
import { http_error } from "../js/http_error";

export default {
  name: 'user',
  components: {
    Breadcrumbs,
    CheckDependency,
    Confirm,
    Complete,
    UsageList
  },
  mixins: [res_list, http_error],
  props: {
    mode: String
  },
  data: function(){
    return {
      module_id: "34",
      data: [],
      progress: 0,
      progress_overlay: false,
      search_uid: "",
      search_name: "",
      user_list_jobs: []
    }
  },
  mounted: function(){
    this.get_data(this.get_prefix() + 'user/', ['list']);
  },
  computed: {
    headers: function() {
      return [
        {
          text: this.$i18n.t("message.common.uid"),
          value: 'uid',
          filter: value => {
            if(this.search_uid === "" || this.search_uid === null){
              return true;
            }
            return value.indexOf(this.search_uid) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.common.name"),
          value: 'name',
          filter: (value, search, item) => {
            if(this.search_name === "" || this.search_name === null){
              return true;
            }
            if(value === null){
              value = item.user;
            }
            return value.indexOf(this.search_name) !== -1;
          }
        },
        { text: this.$i18n.t("message.common.operation"),
          value: 'operation',
          sortable: false
        }
      ];
    }
  },
  methods: {
    get_referer: function(){
      return "?referer=" + encodeURIComponent("/" + this.get_prefix() + "user");
    },
    pre_delete_data: function(iid, uid){
      if(this.$store.getters.rozetta_idp.indexOf(iid) === -1){
        this.delete_data(this.get_prefix() + 'user', [uid], '/list');
      }else{
        // IdP連携
        this.delete_data(this.get_prefix() + 'rozetta_user', [uid], '/list');
      }
    },
    deletable: function(data){
      if(this.$store.getters.debug){
        console.log(this.mode);
      }
      if(this.$store.getters.user.uid === data.uid){
        return false;
      }
      if(this.mode === "user"){
        return this.$store.getters.user.uid === data.uid;
      }else if(this.mode === "group"){
        return this.$store.getters.user.gid === data.gid;
      }else{  // organization
        return true;
      }
    },
    delete_dependency: function(uid, iid){
      if(!this.$refs.check_dependency){
        return;
      }
      var url_postfix = "";
      if(this.$store.getters.user.role !== "user"){
        url_postfix = "/list/" + uid;
      }
      var dependencies = [
        {
          path: this.get_prefix() + "job" + url_postfix,
          title: this.$t("message.common.job")
        },
        {
          path: this.get_prefix() + "file" + url_postfix,
          title: this.$t("message.common.file")
        }
      ];
      if(this.$store.getters.domain === "t-3mt"){
        Array.prototype.push.apply(dependencies,
        [
          {
            path: this.get_prefix() + "model" + url_postfix,
            title: this.$t("message.common.model")
          },
          {
            path: this.get_prefix() + "corpus" + url_postfix,
            title: this.$t("message.common.corpus")
          },
          {
            path: this.get_prefix() + "term" + url_postfix,
            title: this.$t("message.common.term")
          }
        ]);
      }
      dependencies.push({
        path: this.get_prefix() + "translation_preset" + url_postfix,
        title: this.$t("message.common.translation_preset")
      });
      this.$refs.check_dependency.open(dependencies)
        .then( result => {
          if(result){
            this.pre_delete_data(iid, uid);
          }
        });
    },
    get_user_list: function(){
      var lang = "en";
      switch(this.$i18n.locale){
        case "ja":
          lang = "ja";
          break;
      }
      var parameters = Object.assign({}, this.parameters);
      parameters.output_lang = lang;
      parameters.title = this.$i18n.t("message.user.user_list")
        + " (" + this.$i18n.d(new Date(), 'long', this.$store.getters.langs[this.$i18n.locale].locale) + ")";
      parameters.nid = this.$store.getters.user.nid;
      if(this.mode === "group"){
        parameters.gid = this.$store.getters.user.gid;
      }
      this.$http.post(this.$store.getters.api_endpoint + "/" + this.get_prefix() + "action/list_user",
                      parameters,
                      {
                        headers: {
                          'Content-Type': 'application/json'
                        },
                      })
        .then((response) => {
          if(!this.$refs.user_list_confirm){
            return;
          }
          this.user_list_jobs = [{
            jid: response.data.jid,
            name: response.data.title,
            status: "complete"
          }];
          this.$refs.user_list_confirm.open(null, 600)
            .then((result) => {
              this.user_list_jobs = [];
            });
        })
        .catch((error) => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    }
  }
}
</script>
